import { Component, OnInit } from '@angular/core';
import { PermissionsService } from '../../../services/permission.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-master-overview',
  standalone: false,
  templateUrl: './master-overview.component.html',
})
export class MasterOverviewComponent implements OnInit {

  menuItems: MenuItem[] = [];

  constructor(
    private permissionService: PermissionsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadMenuItems();
  }

  loadMenuItems(): void {
    const permissions = JSON.parse(
      sessionStorage.getItem('user_permissions') || '[]'
    );

    const moduleData = permissions.find((item: any) => item.id === 15);

    if (moduleData?.sub_menus) {
      this.menuItems = moduleData.sub_menus;
    } else {
      this.menuItems = [];
    }

    console.log('Menu Items:', this.menuItems);
  }

  navigateToPage(url: string): void {
    if (url) {
      this.router.navigate([url]);
    }
  }

  getActivePrivileges(privileges: Privilege[]): Privilege[] {
    return privileges?.filter(p => p.status) || [];
  }

  isAccess(item: MenuItem): boolean {
    return item?.privileges?.some(p => p.status) || false;
  }

  /* ICON FIX FUNCTION */
  getValidIcon(icon: string | null | undefined): string {

    const iconMap: { [key: string]: string } = {
      'pi pi-warehouse': 'pi pi-building',  // Fix for invalid icon
      'pi pi-chart': 'pi pi-chart-line'
    };

    if (!icon) return 'pi pi-folder';

    return iconMap[icon] || icon;
  }
}


/* Interfaces */

interface Privilege {
  id: number;
  name: string;
  description: string;
  status: boolean;
}

interface MenuItem {
  id: number;
  name: string;
  code: string;
  url: string;
  icon: string;
  sub_menus: any[];
  privileges: Privilege[];
  scheme_id: null | number;
}